export const DialogQuoteBiiShipmentProperties = {
    moneyUp: '../../../../assets/money-up.svg',
};
